<template>
  <div>
    <div class="row mb-1">
      <div class="col-sm-9">
        <h4 class="text-uppercase mt-1">
          {{lexicon.drop_stat_title}}
        </h4>
      </div>
      <div class="col-sm-3 ">
        <date-range-picker v-model="date.period" format="YYYY-MM-DD" :options="date.options"
            class="form-control w-auto float-right " id="dash-picker"/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ countOptions.title.text }}</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <div class="card-text">
                <div v-if="!loading">
                  <apexchart type="area" height="200" :options="countOptions"
                      :series="count"></apexchart>
                </div>
                <template v-else>
                  <div class="text-center">
                    <div class="spinner-border text-primary my-5" role="status">
                      <span class="sr-only">{{ lexicon.drop_loading }}</span>
                    </div>
                  </div>
                </template>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ costOptions.title.text }}</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <div class="card-text">
                <div v-if="!loading">
                  <apexchart type="area" height="200" :options="costOptions"
                      :series="cost"></apexchart>
                </div>
                <template v-else>
                  <div class="text-center">
                    <div class="spinner-border text-primary my-5" role="status">
                      <span class="sr-only">{{ lexicon.drop_loading }}</span>
                    </div>
                  </div>
                </template>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ nalOptions.title.text }}</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <div class="card-text">
                <div v-if="!loading">
                  <apexchart type="area" height="200" :options="nalOptions"
                      :series="nal"></apexchart>
                </div>
                <template v-else>
                  <div class="text-center">
                    <div class="spinner-border text-primary my-5" role="status">
                      <span class="sr-only">{{ lexicon.drop_loading }}</span>
                    </div>
                  </div>
                </template>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ itemsOptions.title.text }}</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <div class="card-text">
                <div v-if="!loading">
                  <apexchart type="area" height="200" :options="itemsOptions"
                      :series="items"></apexchart>
                </div>
                <template v-else>
                  <div class="text-center">
                    <div class="spinner-border text-primary my-5" role="status">
                      <span class="sr-only">{{ lexicon.drop_loading }}</span>
                    </div>
                  </div>
                </template>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-3" id="chart-deck">
        <div class="card-deck">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">
                {{ accessoryOptions.title.text }}
              </h4>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div class="card-text">
                  <div v-if="!loading">
                    <div v-if="!readyAccessory">
                      {{lexicon.drop_no_data_period}}
                    </div>
                    <div v-else>
                      <apexchart type="pie" height="350"
                          :options="accessoryOptions"
                          :series="accessory"/>
                    </div>

                  </div>
                  <template v-else>
                    <div class="text-center">
                      <div class="spinner-border text-primary my-5" role="status">
                        <span class="sr-only">{{ lexicon.drop_loading }}</span>
                      </div>
                    </div>
                  </template>

                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">
                {{ productsOptions.title.text }}
              </h4>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div class="card-text">
                  <div v-if="!loading && products.length">
                    <div v-if="!readyProducts">
                     {{lexicon.drop_no_data_period}}
                    </div>
                    <div v-else>
                      <apexchart type="bar" height="350" :options="productsOptions"
                          :series="products"></apexchart>
                    </div>
                  </div>
                  <template v-else>
                    <div class="text-center">
                      <div class="spinner-border text-primary my-5" role="status">
                        <span class="sr-only">{{ lexicon.drop_loading }}</span>
                      </div>
                    </div>
                  </template>

                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">
                {{ cityOptions.title.text }}
              </h4>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div class="card-text">
                  <div v-if="!loading">
                    <div v-if="!readyCity">
                       {{lexicon.drop_no_data_period}}
                    </div>
                    <div v-else>
                      <apexchart type="bar" height="350" :options="cityOptions"
                          :series="city"></apexchart>
                    </div>
                  </div>
                  <template v-else>
                    <div class="text-center">
                      <div class="spinner-border text-primary my-5" role="status">
                        <span class="sr-only">{{ lexicon.drop_loading }}</span>
                      </div>
                    </div>
                  </template>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
var ru = require("apexcharts/dist/locales/ru.json")
import axios from "axios";
import {mapState} from 'vuex'
// function generateDayWiseTimeSeries(baseval, count, yrange) {
//     var i = 0;
//     var series = [];
//     while (i < count) {
//         var x = baseval;
//         // var x = window.moment(baseval).format('DD.MM.YYYY');
//         var y =
//             Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
//
//         series.push({"x": x, "y": y});
//         baseval += 86400000;
//         i++;
//     }
//     console.log(series)
//     return series;
// }

export default {
  name: 'dashboard',
  data: function () {
    return {
      date: {
        period: [window.moment().add(-14, 'day').format('DD.MM.YYYY'), window.moment().format('DD.MM.YYYY')],
        options: {
          startDate: window.moment().add(-14, 'day'),
          endDate: window.moment(),
          minYear: 2018,
          maxYear: +window.moment().format("YYYY"),
          // locale: {
          //   format: 'DD.MM.YYYY'
          // },
          autoApply: true,
          showDropdowns: true,
        }
      },
      readyCity: false,
      readyProducts: false,
      readyAccessory: false,
      loading: true,
      count: [],
      cost: [],
      nal: [],
      items: [],
      accessory: [],
      products: [{
        data: []
      }],
      city: [{
        data: []
      }],
      countOptions: {
        chart: {
          id: 'chart-count',
          locales: [ru],
          defaultLocale: 'ru',
          group: 'social',
          type: 'line',
          height: 200
        },
        dataLabels: {
          enabled: true,
        },
        colors: ['#008FFB'],
        markers: {
          size: 5,
          hover: {
            size: 9
          }
        },
        xaxis: {
          tooltip: {
            enabled: false
          }
        },
        title: {
          text: 'Заказы',
          style: {
            fontSize: 0
          }
        },
        yaxis: {
          labels: {
            minWidth: 40
          }
        }
      },
      costOptions: {
        chart: {
          id: 'chart-cost',
          locales: [ru],
          defaultLocale: 'ru',
          group: 'social',
          type: 'line',
          height: 200
        },
        dataLabels: {
          enabled: true,
        },
        colors: ['#546E7A'],
        markers: {
          size: 5,
          hover: {
            size: 9
          }
        },
        xaxis: {
          tooltip: {
            enabled: false
          }
        },
        title: {
          text: 'Общая стоимость',
          style: {
            fontSize: 0
          }
        },
        yaxis: {
          labels: {
            minWidth: 40
          }
        }
      },
      nalOptions: {
        chart: {
          id: 'chart-nal',
          group: 'social',
          locales: [ru],
          defaultLocale: 'ru',
          type: 'area',
          height: 200
        },
        colors: ['#00E396'],

        xaxis: {
          tooltip: {
            enabled: false
          }
        },
        title: {
          text: '',
          style: {
            fontSize: 0
          }
        },
        yaxis: {
          title: {
            text: ''
          },
          labels: {
            minWidth: 40
          }
        }
      },
      itemsOptions: {
        chart: {
          id: 'chart-items',
          group: 'social',
          locales: [ru],
          defaultLocale: 'ru',
          type: 'area',
          height: 200
        },
        colors: ['#15D3D5'],

        xaxis: {
          tooltip: {
            enabled: false
          }
        },
        title: {
          text: '',
          style: {
            fontSize: 0
          }
        },
        yaxis: {
          title: {
            text: ''
          },
          labels: {
            minWidth: 40
          }
        }
      },
      accessoryOptions: {
        title: {
          text: 'Заказы с аксессуарами',
          style: {
            fontSize: 0
          }
        },
        labels: ['Без аксессуаров', 'С аксессуарами'],
        dataLabels: {
          enabled: true
        },
        legend: {
          position: 'bottom'
        },
        chart: {
          type: 'pie',
          offsetY: 0,
          height: 350,
          dropShadow: {
            enabled: false,
            blur: 5,
            left: 1,
            top: 1,
            opacity: 0.2
          },
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: 5
        },
        colors: ['#7961F9', '#FF9F43', '#EA5455'],
        fill: {
          type: 'gradient',
          gradient: {
            gradientToColors: ['#9c8cfc', '#FFC085', '#f29292']
          }
        }
      },
      cityOptions: {
        chart: {
          type: 'bar',
          height: 350,
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
          }
        },
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          enabled: false
        },
        title: {
          text: 'Топ по городам',
          style: {
            fontSize: 0
          }
        }
      },
      productsOptions: {
        chart: {
          type: 'bar',
          height: 350,
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
          }
        },
        dataLabels: {
          enabled: true
        },
        colors: ['#7367f0'],
        xaxis: {
          categories: [],
        },
        tooltip: {
          enabled: false
        },
        title: {
          text: 'Топ по товарам', //this.lexicon.drop_prod_top
          style: {
            fontSize: 0
          }
        }
      }
    }
  },
  created() {
    // Event.$on('wait-period', this.changePeriod)
    // Event.$on('vue-tables.filter', this.tableEvents)
    this.fetchData()

  },
  watch: {
    $route: 'fetchData',
    'date.period': function () {
      this.fetchData()
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      axios.post('stat/', {'start': this.date.period[0], 'end': this.date.period[1]}).then((response) => {
        this.count = [{
          name: response.data.data.count.name,
          data: response.data.data.count.data
        }]
        this.countOptions.title.text = response.data.data.count.name
        this.cost = [{
          name: response.data.data.cost.name,
          data: response.data.data.cost.data
        }]
        this.costOptions.title.text = response.data.data.cost.name
        this.nal = [{
          name: response.data.data.nal.name,
          data: response.data.data.nal.data
        }]
        this.nalOptions.title.text = response.data.data.nal.name
        this.items = [{
          name: response.data.data.items.name,
          data: response.data.data.items.data
        }]
        this.products = [{data: response.data.data.products.value}]
        this.productsOptions.xaxis.categories = response.data.data.products.label
        if (response.data.data.products.value) {
          this.readyProducts = true;
        }
        this.city = [{data: response.data.data.city.value}]
        if (response.data.data.city.value) {
          this.readyCity = true;
        }
        this.cityOptions.xaxis.categories = response.data.data.city.label
        this.itemsOptions.title.text = response.data.data.items.name
        this.accessory = response.data.data.accessory
        if (this.accessory[0] + this.accessory[1] > 0) {
          this.readyAccessory = true;
        }
        this.cityOptions.title.text  =this.lexicon.drop_city_top
        this.accessoryOptions.title.text  =this.lexicon.drop_orders_accs
        this.accessoryOptions.labels =  [this.lexicon.drop_order_wo_accs,this.lexicon.drop_order_wth_accs],
        this.productsOptions.title.text  = this.lexicon.drop_prod_top
        this.loading = false
      })
    },
    changePeriod() {
      // Event.$emit('change-period', this.period);
    }
  },
  computed: mapState({
    lexicon: state => state.lexicon
  })
}
</script>
